import React, { useEffect, useState } from 'react';

const ToggleSwitch = ({ isActive, isExtFunc = false, onToggle }) => {
  const [isOn, setIsOn] = useState(isActive); // Use initial state based on isActive prop

  const handleToggle = () => {
    setIsOn(!isOn); // Toggle the state
  };
  useEffect(() => {
    setIsOn(isActive);
  }, [isActive])
  return (
    <label className="switch">
      <input
        type="checkbox"
        checked={isActive}
        onChange={!isExtFunc ? handleToggle : onToggle}
      />
      <span className="slider">
        <span className="slider-text">{isOn ? 'On' : 'Off'}</span>
      </span>
    </label>
  );
};

export default ToggleSwitch;

